import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

import home from './modules/home'
import auth from './modules/auth'
import loading from './modules/loading'
import sidebar from './modules/sidebar'
import dashboard from './modules/dashboard'
import company from './modules/company'
import branches from './modules/branches'
import employee from './modules/employee'
import menu from './modules/menu'
import users from './modules/users'
import contact from './modules/contact'
import units from './modules/units'
import jobtitle from './modules/jobtitle'
import jobposition from './modules/jobposition'
import employeestatus from './modules/employeestatus'
import educations from './modules/educations'
import attendances from './modules/attendances'
import global from './modules/global'
import provinces from './modules/provinces'
import cities from './modules/cities'
import districts from './modules/districts'
import villages from './modules/villages'
import banks from './modules/banks'
import confirmations from './modules/confirmations'
import mastermenu from './modules/mastermenu'
import mastermenurole from './modules/mastermenurole'
import masterrole from './modules/masterrole'
import leaves from './modules/leaves'

Vue.use(Vuex)

const secureLS = new SecureLS({
  encodingType: 'aes',
  encryptionSecret: 'vue-auth-persist'
})

const authState = createPersistedState({
  key: 'user-persist-state',
  paths: ['auth.user'],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key)
  }
})

const sidebarState = createPersistedState({
  key: 'sidebar-persist-state',
  paths: ['sidebar.sidebar'],
  storage: {
    getItem: (key) => secureLS.get(key),
    setItem: (key, value) => secureLS.set(key, value),
    removeItem: (key) => secureLS.remove(key)
  }
})

export default new Vuex.Store({
  modules: {
    home: home,
    auth: auth,
    loading: loading,
    sidebar: sidebar,
    dashboard: dashboard,
    company: company,
    branches: branches,
    employee: employee,
    menu: menu,
    users: users,
    contact: contact,
    units: units,
    jobtitle: jobtitle,
    jobposition: jobposition,
    employeestatus: employeestatus,
    educations: educations,
    attendances: attendances,
    global: global,
    provinces: provinces,
    cities: cities,
    districts: districts,
    villages: villages,
    banks: banks,
    confirmations: confirmations,
    mastermenu: mastermenu,
    mastermenurole: mastermenurole,
    masterrole: masterrole,
    leaves: leaves
  },
  plugins: [authState, sidebarState]
})
